import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from 'tailwind-merge';
import { useTheme } from '../../';
import { mergeDeep } from '../../helpers/merge-deep';
export const Blockquote = ({ children, className, theme: customTheme = {}, ...props }) => {
    const theme = mergeDeep(useTheme().theme.blockquote, customTheme);
    return (_jsx("blockquote", { className: twMerge(theme.root.base, className), "data-testid": "flowbite-blockquote", ...props, children: children }));
};
Blockquote.displayName = 'Blockquote';
